define(["require", "exports", "tslib", "mobx", "../model/services/EventManager"], function (require, exports, tslib_1, mobx_1, EventManager_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.NotificationStore = void 0;
    class NotificationStore {
        constructor(storeManager) {
            Object.defineProperty(this, "storeManager", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "isOpen", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: false
            });
            Object.defineProperty(this, "msg", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ""
            });
            Object.defineProperty(this, "onClose", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: (e) => {
                    this.isOpen = false;
                }
            });
            (0, mobx_1.makeObservable)(this);
            this.storeManager = storeManager;
            EventManager_1.EventManager.Instance.on("notification", (msg) => {
                this.push(msg);
            });
        }
        push(msg) {
            return new Promise((resolve, reject) => {
                this.msg = msg;
                this.isOpen = true;
                resolve(1);
            });
        }
    }
    exports.NotificationStore = NotificationStore;
    tslib_1.__decorate([
        mobx_1.observable
    ], NotificationStore.prototype, "isOpen", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], NotificationStore.prototype, "msg", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], NotificationStore.prototype, "onClose", void 0);
});
